import { render, staticRenderFns } from "./IdentificationCodeInput.vue?vue&type=template&id=057e8dab"
import script from "./IdentificationCodeInput.vue?vue&type=script&lang=js"
export * from "./IdentificationCodeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports